export enum PrescriptionTypeFilterIds {
    MULTIFOCAL_TORIC = 615,
    TORIC_ASTIGMATISM = 251,
    MULTIFOCAL = 252,
    SINGLE_VISION = 250,
}

export const CONTACTS_NEW_30_COUPON = 'CONTACTNEW30';
const CONTACTS_FIRST_COUPON = 'CONTACTSFIRST';

// not a good solution, but decided to use it until autoApplyCL exp is finished
// need to find better solution for hiding CL coupons in the future if the exp wins
export const CL_COUPONS_TO_HIDE = [CONTACTS_NEW_30_COUPON, CONTACTS_FIRST_COUPON];
